import { DoctorLayout } from "@/components/layout/doctor-layout";
import { CpdModuleReaderContent } from "@/components/cpd/cpd-module-reader";

export default function DoctorLearnModule() {
  return (
    <DoctorLayout title="CPD Learning Hub">
      <CpdModuleReaderContent listPath="/doctor/learn" />
    </DoctorLayout>
  );
}
